import React from 'react';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Tabs from './tabs';
import WalletMismatchModal from '@/components/WalletMismatchModal';
import useModalStore from '@/stores/useModalStore';

function Dashboard() {
    const showWalletMissmatchModal = useModalStore(state => state.walletMissMatch.show);

    return (
        <div
            className={`
                h-fit bg-black overflow-x-hidden
                lg:grid lg:grid-cols-1
                2xl:grid-cols-[469px_1fr] 2xl:grid-rows-[auto_1fr]
            `}
        >
            <aside className="hidden 2xl:block 2xl:row-span-2 pl-8 pr-3">
                <Sidebar/>
            </aside>


            <div className='overflow-x-hidden'>
                <Header/>
                <main className="py-6">
                    <Tabs/>
                </main>
            </div>
            {showWalletMissmatchModal && (
                <WalletMismatchModal />
            )}
        </div>
    )
};

export default Dashboard;